import {ENDPOINT_HISTORY} from 'common/endpoints';
import {commonJwtHeader} from 'common/utils';

const getHistoryByGrantId = (token, grantNumber, page) => {
  let pageQuery = page !== 0 ? `&page=${page}` : '';
  let historyEndPoint = `${ENDPOINT_HISTORY}?awardNumber=${grantNumber}${pageQuery}`;

  return fetch(historyEndPoint, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

export default {
  getHistoryByGrantId,
};
